__turbopack_context__.v({
  "footerAccordianButton": "styles-module__SuJP_G__footerAccordianButton",
  "footerAppBadges": "styles-module__SuJP_G__footerAppBadges",
  "footerAppDownload": "styles-module__SuJP_G__footerAppDownload",
  "footerAppDownloadDesktopContainer": "styles-module__SuJP_G__footerAppDownloadDesktopContainer",
  "footerAppDownloadSocialBadges": "styles-module__SuJP_G__footerAppDownloadSocialBadges",
  "footerAppDownloadText": "styles-module__SuJP_G__footerAppDownloadText",
  "footerAppSocialContainer": "styles-module__SuJP_G__footerAppSocialContainer",
  "footerAppSocialRow": "styles-module__SuJP_G__footerAppSocialRow",
  "footerColumn": "styles-module__SuJP_G__footerColumn",
  "footerColumnDesktopContainer": "styles-module__SuJP_G__footerColumnDesktopContainer",
  "footerColumnMobileContainer": "styles-module__SuJP_G__footerColumnMobileContainer",
  "footerColumnTitle": "styles-module__SuJP_G__footerColumnTitle",
  "footerCookieButton": "styles-module__SuJP_G__footerCookieButton",
  "footerLink": "styles-module__SuJP_G__footerLink",
  "footerLinkWrapper": "styles-module__SuJP_G__footerLinkWrapper",
  "footerLocalisationContainer": "styles-module__SuJP_G__footerLocalisationContainer",
  "footerLowerContainer": "styles-module__SuJP_G__footerLowerContainer",
  "footerLowerContent": "styles-module__SuJP_G__footerLowerContent",
  "footerLowerDesktopColumn": "styles-module__SuJP_G__footerLowerDesktopColumn",
  "footerQRCodeContainer": "styles-module__SuJP_G__footerQRCodeContainer",
  "footerQRCodeText": "styles-module__SuJP_G__footerQRCodeText",
  "footerSocialColumn": "styles-module__SuJP_G__footerSocialColumn",
  "footerUpperContainer": "styles-module__SuJP_G__footerUpperContainer",
  "footerUpperContent": "styles-module__SuJP_G__footerUpperContent",
  "selectLanguage": "styles-module__SuJP_G__selectLanguage",
  "selectLocation": "styles-module__SuJP_G__selectLocation",
  "socialBadges": "styles-module__SuJP_G__socialBadges",
  "socialLink": "styles-module__SuJP_G__socialLink",
  "socialListItem": "styles-module__SuJP_G__socialListItem",
});
